// Google refuses OAuth inside embedded webviews (403 disallowed_useragent),
// and the big social apps' in-app browsers identify themselves in the user agent.
const META_IN_APP_RE = /FBAN|FBAV|FB_IAB|Instagram/;
// Messenger on iOS reports FBAN/MessengerForiOS, on Android FB_IAB/MESSENGER
// or FB_IAB/Orca-Android (Orca is Messenger's internal name).
const MESSENGER_RE = /MessengerForiOS|FB_IAB\/(MESSENGER|Orca-Android)/;
const LINKEDIN_RE = /LinkedInApp/;
const TIKTOK_RE = /musical_ly|BytedanceWebview|TikTok/;

export type InAppBrowserApp = "instagram" | "facebook" | "messenger" | "linkedin" | "tiktok";

export interface InAppBrowser {
  app: InAppBrowserApp;
  android: boolean;
  ios: boolean;
}

const APP_NAMES: Record<InAppBrowserApp, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  messenger: "Messenger",
  linkedin: "LinkedIn",
  tiktok: "TikTok",
};

export function inAppBrowserAppName(app: InAppBrowserApp): string {
  return APP_NAMES[app];
}

function detectApp(userAgent: string): InAppBrowserApp | null {
  if (MESSENGER_RE.test(userAgent)) return "messenger";
  if (/Instagram/.test(userAgent)) return "instagram";
  if (META_IN_APP_RE.test(userAgent)) return "facebook";
  if (LINKEDIN_RE.test(userAgent)) return "linkedin";
  if (TIKTOK_RE.test(userAgent)) return "tiktok";
  return null;
}

export function detectInAppBrowser(userAgent: string): InAppBrowser | null {
  const app = detectApp(userAgent);
  if (!app) return null;
  return {
    app,
    android: /Android/i.test(userAgent),
    // iPadOS reports a Macintosh UA; Meta's iOS apps also add FBIOS.
    ios: /iPhone|iPad|iPod|FBIOS|Macintosh/.test(userAgent),
  };
}

/** Android's intent:// scheme hands the exact URL to Chrome, with the
 *  normal https URL as the fallback if Chrome is not installed. */
export function chromeIntentUrl(href: string): string {
  const url = new URL(href);
  const fallback = encodeURIComponent(url.href);
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${url.protocol.replace(":", "")};package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
}

export function currentInAppBrowser(): InAppBrowser | null {
  if (typeof navigator === "undefined") return null;
  return detectInAppBrowser(navigator.userAgent);
}
